<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
<div class="form-horizontal">

  
        <!--Datum Western Union izveštaja-->
        
          <div class="form-group row">
            <div class="col-md-12">
              <yt-fw-date-picker-popup
                formControlName="Datum"                 
                [Label]="'WESTERNUNION.DATUM.SINGULAR'">
              </yt-fw-date-picker-popup>
              <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
              <span *ngFor="let validation of errorMessages.Datum">
                <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)">
                  <span [ngClass]="{'slideInRight': fc.Datum.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                  </span>
                </span>
              </span>
              </div>
            </div>
   </div>
    
      
  
  <!--Ukupno ISPLATA RSD-->

            <div class="form-group row">
                <label class="col-form-label col-md-5">
                <span translate="WESTERNUNION.UKUPNOISPLATARSD.SINGULAR"></span>
                </label>          
                <div class="col-md-7">
                    <yt-number-input-v2
                    formControlName="UkupnoIsplataRsd"
                    >
                    </yt-number-input-v2>
                    <div class="form-error" *ngIf="submitted && fc.UkupnoIsplataRsd.invalid">
                        <span *ngFor="let validation of errorMessages.UkupnoIsplataRsd">
                          <span class="error-message" *ngIf="fc.UkupnoIsplataRsd.hasError(validation.type)">
                            <span [ngClass]="{'slideInRight': fc.UkupnoIsplataRsd.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                            </span>
                          </span>
                        </span>
                    </div>
                </div>
            </div>

              
  <!--Ukupno ISPLATA EUR-->

  <div class="form-group row">
    <label class="col-form-label col-md-5">
    <span translate="WESTERNUNION.UKUPNOISPLATAEUR.SINGULAR"></span>
    </label>          
    <div class="col-md-7">
        <yt-number-input-v2
        formControlName="UkupnoIsplataEur"
        >
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.UkupnoIsplataEur.invalid">
            <span *ngFor="let validation of errorMessages.UkupnoIsplataEur">
              <span class="error-message" *ngIf="fc.UkupnoIsplataEur.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.UkupnoIsplataEur.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                </span>
              </span>
            </span>
        </div>
    </div>
</div>


  <!--Ukupno UPLATA-->
 
            <div class="form-group row">
                <label class="col-form-label col-md-5">
                <span translate="WESTERNUNION.UKUPNOUPLATA.SINGULAR"></span>
                </label>          
                <div class="col-md-7">
                    <yt-number-input-v2
                    formControlName="UkupnoUplata"
                    >
                    </yt-number-input-v2>
                    <div class="form-error" *ngIf="submitted && fc.UkupnoUplata.invalid">
                        <span *ngFor="let validation of errorMessages.UkupnoUplata">
                          <span class="error-message" *ngIf="fc.UkupnoUplata.hasError(validation.type)">
                            <span [ngClass]="{'slideInRight': fc.UkupnoUplata.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                            </span>
                          </span>
                        </span>
                    </div>    
                </div>
            </div>
    
  
           <!--Ukupno PROVIZIJA-->

                <div class="form-group row">
                    <label class="col-form-label col-md-5">
                    <span translate="WESTERNUNION.UKUPNOPROVIZIJA.SINGULAR"></span>
                    </label>          
                    <div class="col-md-7">                
                        <yt-number-input-v2
                        formControlName="UkupnoProvizija"
                        >
                        </yt-number-input-v2> 
                        <div class="form-error" *ngIf="submitted && fc.UkupnoProvizija.invalid">
                            <span *ngFor="let validation of errorMessages.UkupnoProvizija">
                              <span class="error-message" *ngIf="fc.UkupnoProvizija.hasError(validation.type)">
                                <span [ngClass]="{'slideInRight': fc.UkupnoProvizija.hasError(validation.type), 'animated': true}" translate="{{validation.message}}">
                                </span>
                              </span>
                            </span>
                        </div>    
                    </div>
                </div>
</div>
</form>
  
  